import { useQuery } from '@tanstack/react-query'
import AnalyticsApi from '@/infrastructure/api/analytics'
import { useAnalyticsScope } from '@/hooks'

export function useProductReturnRate(
  isReturnRateAnalyticsAllowed: boolean,
  productId?: string,
  startDate?: string,
  endDate?: string,
  countries?: string[]
) {
  const { ecommerceIds } = useAnalyticsScope()

  async function callProductReturnRate() {
    if (!ecommerceIds.length || !productId) return
    return AnalyticsApi.getProductReturnRate({
      productId,
      ecommerceId: ecommerceIds[0],
      ecommerceIds,
      startDate,
      endDate,
      countries
    })
  }

  const periodReturnRateQuery = useQuery({
    queryKey: [
      'productReturnRate',
      productId,
      ecommerceIds,
      startDate,
      endDate,
      countries
    ],
    queryFn: callProductReturnRate,
    staleTime: 1000 * 60 * 15,
    enabled:
      ecommerceIds.length > 0 &&
      !!productId &&
      !!startDate &&
      !!endDate &&
      isReturnRateAnalyticsAllowed &&
      countries !== undefined
  })

  return {
    productReturnRate: periodReturnRateQuery.data,
    loadingProductReturnRate: periodReturnRateQuery.isLoading
  }
}
